"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.calculADR = void 0;
Object.defineProperty(exports, "disciplines", {
  enumerable: true,
  get: function get() {
    return _constants.disciplines;
  }
});
Object.defineProperty(exports, "experiences", {
  enumerable: true,
  get: function get() {
    return _constants.experiences;
  }
});
Object.defineProperty(exports, "jobs", {
  enumerable: true,
  get: function get() {
    return _constants.jobs;
  }
});

var _constants = require("./constants");

var _group_all = _interopRequireDefault(require("./data/group_all.js"));

var _group_disciplines = _interopRequireDefault(require("./data/group_disciplines.js"));

var _group_experiences = _interopRequireDefault(require("./data/group_experiences.js"));

var _group_jobs = _interopRequireDefault(require("./data/group_jobs.js"));

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    "default": obj
  };
}

var findData = function findData(data, filters) {
  var result = data.filter(filters);
  if (result.length > 0) return Math.round(result[0].tjm_moyen);
  return 0;
};

var calculADR = function calculADR(_ref) {
  var _ref$job = _ref.job,
      job = _ref$job === void 0 ? null : _ref$job,
      _ref$discipline = _ref.discipline,
      discipline = _ref$discipline === void 0 ? null : _ref$discipline,
      _ref$experience = _ref.experience,
      experience = _ref$experience === void 0 ? null : _ref$experience;
  var adr = 0;
  var jobStatus = null; // Check job type

  if (_constants.ingenieur_jobs.includes(job)) jobStatus = 'Ingénieur (Directeur de projet, chargé d\'études, etc)';else if (_constants.technician_jobs.includes(job)) jobStatus = 'Projeteur';

  if (jobStatus && discipline) {
    adr = findData(_group_all["default"], function (elem) {
      return elem.poste_cleaned === jobStatus && elem.disciplines_cleaned === discipline && elem.experience_pro === experience;
    });
    if (adr !== 0) return adr;
  }

  if (jobStatus) {
    adr = findData(_group_jobs["default"], function (elem) {
      return elem.poste_cleaned === jobStatus && elem.experience_pro === experience;
    });
    if (adr !== 0) return adr;
  }

  if (discipline) {
    adr = findData(_group_disciplines["default"], function (elem) {
      return elem.disciplines_cleaned === discipline && elem.experience_pro === experience;
    });
    if (adr !== 0) return adr;
  }

  adr = findData(_group_experiences["default"], function (elem) {
    return elem.experience_pro === experience;
  });
  return adr;
};

exports.calculADR = calculADR;